module.exports = __webpack_public_path__ + "img/yiPay.b0d578bd.png";